import { Box } from '@wix/design-system';
import React, { Children, FC } from 'react';

import s from './ButtonsGrid.scss';

type ButtonsGridProps = {
  columnsCount?: 1 | 2;
};

export const ButtonsGrid: FC<ButtonsGridProps> = ({ children, columnsCount = 1 }) => {
  const childrenArray = Children.toArray(children);

  return (
    <Box
      direction={columnsCount === 1 ? 'vertical' : 'horizontal'}
      overflow="hidden"
      flexWrap="wrap"
      className={columnsCount === 1 || childrenArray.length === 1 ? s.oneColumnLayout : s.twoColumnLayout}
    >
      {Children.map(childrenArray, (child) => {
        return (
          <Box className={s.cell} direction="vertical" overflow="hidden">
            {child}
          </Box>
        );
      })}
    </Box>
  );
};
